import type { SchemaLine } from './types'

/**
 * The single selection rule for line colors in UI chrome (2026-07 color
 * contract): pills / badges / rails / suggester dots must render the
 * SAME hex the map draws for the line in the active theme. The map's
 * per-theme MMTG geometry is baked from `line.colorModes`, so UI chrome
 * selects `colorModes[theme]` too; the flat legacy `hexColor` is only
 * the fallback for schemas that predate the field.
 *
 * Guarded by `src/state/lineColorParity.test.ts`, which asserts this
 * selection equals the actual per-vertex color inside the bundled
 * `connections-{light,dark}.mmtg` for every line, both themes.
 */
export function lineHexForTheme(line: SchemaLine, theme: 'light' | 'dark'): string {
  return line.colorModes?.[theme] ?? line.hexColor
}
